module.exports = __webpack_public_path__ + "static/media/Vitriol.c8ee1bdb.svg";